// PM, PM2, PM3 y PMI en el mismo desplegable que los catálogos (CatalogSelect). Sus opciones
// son usuarios (GET /api/obras/responsables, por rol), no un catálogo: se guarda el
// CodUsuario y se enseña el nombre.

// Opciones del desplegable y texto del valor actual. `cod`: CodUsuario asignado;
// `nombreActual`: el nombre que trae la obra (por si ese usuario ya no está en la lista).
export function responsableOptions(responsables = [], cod, nombreActual) {
    const options = (responsables || []).map((usuario) => ({ id: Number(usuario.codUsuario), value: usuario.nombre, parent: null, active: true }));
    if (cod == null || cod === "") return { options, label: "" };
    const selected = options.find((option) => option.id === Number(cod));
    if (selected) return { options, label: selected.value };
    // Asignado a alguien que ya no tiene ese rol: se enseña como un valor deshabilitado
    // (en ámbar, igual que en los catálogos) y se puede cambiar o quitar.
    const retirado = { id: Number(cod), value: nombreActual || `Usuario ${cod}`, parent: null, active: false };
    return { options: [...options, retirado], label: retirado.value };
}

// CodUsuario que se guarda al elegir una opción (null = quitar el responsable).
export const responsableCod = (option) => (option ? Number(option.id) : null);

// ── Nombres en el historial y en los cambios pendientes ───────────────────────────
// Campos que se guardan (y se auditan) por CodUsuario, con el campo que trae su nombre.
export const USUARIO_FIELDS = { codPm: "pm", codPm2: "pm2", codPm3: "pm3", codPmi: "pmi" };

// CodUsuario -> nombre: los responsables de cada rol y los que ya tienen asignados las obras.
export function userNames(responsablesByRol = {}, obras = []) {
    const names = new Map();
    (obras || []).forEach((obra) => {
        Object.entries(USUARIO_FIELDS).forEach(([codField, nameField]) => {
            const cod = Number(obra?.[codField]);
            if (cod && obra[nameField]) names.set(cod, obra[nameField]);
        });
    });
    Object.values(responsablesByRol || {}).flat().forEach((usuario) => {
        if (usuario?.codUsuario != null && usuario.nombre) names.set(Number(usuario.codUsuario), usuario.nombre);
    });
    return names;
}

// Texto de un valor de un campo de usuario ("13" -> "Jefferson Suárez Sánchez"). `text`: el
// nombre que ya trae el historial del API. null si el campo no es de usuario o está vacío.
export function userValueText(field, value, names, text) {
    if (!(field in USUARIO_FIELDS) || value === "" || value === null || value === undefined) return null;
    return text || names?.get(Number(value)) || `Usuario ${value}`;
}
